/* AdVille - Piuma Rosa. Generato da tema/sezioni.py: non si modifica a mano. */
/* Ogni sezione chiama questo file: gira una volta sola, la prima. */
if(!window.__avpr){ window.__avpr = 1;

(function(){
  /* la barra in cima gira: ferma, delle quattro promesse se ne leggeva una */
  var voci=[].slice.call(document.querySelectorAll('.annuncio'));
  if(voci.length>1){
    var i=0;
    setInterval(function(){
      voci[i].classList.remove('vivo');
      i=(i+1)%voci.length;
      voci[i].classList.add('vivo');
    },4200);
  }
  /* le foto si scorrono dalla tessera, e i pallini lo dicono */
  document.querySelectorAll('.visore').forEach(function(v){
    var lastre=[].slice.call(v.querySelectorAll('.lastra'));
    var punti=[].slice.call(v.querySelectorAll('.pallino'));
    if(punti.length<2) return;
    function vai(n){
      lastre.forEach(function(l){ l.classList.toggle('viva', +l.dataset.i===n); });
      punti.forEach(function(p){ p.classList.toggle('vivo', +p.dataset.i===n); });
    }
    punti.forEach(function(p){
      p.addEventListener('click', function(e){ e.preventDefault(); vai(+p.dataset.i); });
      p.addEventListener('mouseenter', function(){ vai(+p.dataset.i); });
    });
    var x0=null;
    v.addEventListener('touchstart', function(e){ x0=e.touches[0].clientX; }, {passive:true});
    v.addEventListener('touchend', function(e){
      if(x0===null) return;
      var d=e.changedTouches[0].clientX-x0; x0=null;
      if(Math.abs(d)<34) return;
      var ora=punti.findIndex(function(p){ return p.classList.contains('vivo'); });
      vai(Math.min(punti.length-1, Math.max(0, ora + (d<0?1:-1))));
    }, {passive:true});
  });
})();


/* ---------------------------------- il cassetto, col carrello vero di Shopify */
(function(){
  var cassetto=document.getElementById('cassetto');
  if(!cassetto) return;
  var velo=document.getElementById('velo-cassetto');
  var D={};
  try{ D=JSON.parse(document.getElementById('cs-dati').textContent||'{}'); }catch(e){}
  var SOGLIA=D.soglia||0, PROPOSTE=D.proposte||[], TITOLO=D.titolo_cross||'Da abbinare';
  var SCONTO=D.sconto||0;

  /* La radice serve per i mercati: il menu del negozio punta a /en/, e li'
     dentro le chiamate del carrello vanno a /en/cart/add.js. Senza radice si
     aggiunge al carrello della lingua sbagliata e il numero in testata non si
     muove. */
  var RAD=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';

  function euro(c){ return (c/100).toFixed(2).replace('.',',')+' €'; }
  /* Liquid manda gia' l'indirizzo con la sua larghezza. Riaggiungerne una
     seconda darebbe due `width=` nello stesso indirizzo, e a quel punto quale
     vince lo decide il CDN, non noi. */
  function foto(u,l){
    if(!u) return '';
    if(u.indexOf('width=')>=0) return u;
    return u+(u.indexOf('?')<0?'?':'&')+'width='+(l||200);
  }

  var occupato=false;
  function posta(via, dati){
    occupato=true;
    return fetch(RAD+via, {method:'POST', credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(dati)})
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
      .then(function(e){
        occupato=false;
        /* Shopify risponde 422 con una descrizione leggibile quando la
           variante non e' piu' acquistabile: mostrarla e' meglio che lasciare
           il cassetto fermo e far pensare che il tocco non sia arrivato. */
        if(!e.ok) throw new Error(e.j && e.j.description || 'Non e’ stato possibile aggiornare il carrello.');
        return e.j;
      }, function(err){ occupato=false; throw err; });
  }
  function stato(){
    return fetch(RAD+'cart.js', {credentials:'same-origin', headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); });
  }

  function aggiungi(id, quanti){
    if(occupato) return;
    return posta('cart/add.js', {items:[{id:+id, quantity:quanti||1}]})
      .then(function(){ return aggiorna(true); })
      .catch(avvisa);
  }
  function cambia(linea, quanti){
    if(occupato) return;
    return posta('cart/change.js', {line:+linea, quantity:quanti})
      .then(function(c){ disegna(c); }).catch(avvisa);
  }
  function avvisa(e){
    var b=document.getElementById('cs-righe');
    if(b) b.insertAdjacentHTML('afterbegin','<div class="cs-guaio">'+
      (e && e.message ? e.message : 'Qualcosa non ha funzionato.')+'</div>');
    apri();
  }

  function aggiorna(apriDopo){
    return stato().then(function(c){ disegna(c); if(apriDopo) apri(); });
  }

  /* ------------------------------------------------------------- le righe */

  function riga(x, i){
    var nome = x.product_title +
      (x.variant_title && x.variant_title !== 'Default Title'
        ? '<span class="pz">'+x.variant_title+'</span>' : '');
    var pieno = x.original_line_price > x.final_line_price
      ? '<s>'+euro(x.original_line_price)+'</s>' : '';
    return '<div class="cs-riga">'+
      '<img src="'+foto(x.image)+'" alt="" loading="lazy">'+
      '<div><span class="nm">'+nome+'</span>'+
      '<span class="cs-qta">'+
        '<button type="button" data-linea="'+(i+1)+'" data-quanti="'+(x.quantity-1)+'" aria-label="Uno in meno">&minus;</button>'+
        '<span>'+x.quantity+'</span>'+
        '<button type="button" data-linea="'+(i+1)+'" data-quanti="'+(x.quantity+1)+'" aria-label="Uno in piu">+</button>'+
      '</span></div>'+
      '<div class="pr">'+euro(x.final_line_price)+pieno+'</div></div>';
  }

  /* ---------------------------------------------------------- il cross-sell */
  //
  // Un prodotto con piu' varianti non si aggiunge alla cieca: le pastiglie
  // mostrano le pietre con la loro fotografia e il tocco sceglie quella li'.
  // Le varianti gia' nel carrello spariscono dalla proposta: riproporre quello
  // che uno ha appena messo dentro e' il modo piu' veloce per sembrare un
  // programma invece che un negozio.

  function proposta(p, dentro, altri){
    var libere=(p.varianti||[]).filter(function(v){ return !dentro[v.id]; });
    if(!libere.length) return '';
    var v0=libere[0];

    /* Il prezzo scontato si mostra SOLO quando lo sconto scatterebbe davvero,
       cioe' quando nel carrello c'e' gia' un altro pezzo: lo sconto automatico
       su Shopify e' un "prendi X, ottieni Y", non un ribasso sul prodotto.
       Scrivere 11,96 su un carrello vuoto sarebbe una promessa che la cassa
       smentisce, ed e' esattamente il modo di perdere un ordine gia' fatto. */
    var prezzo;
    if(SCONTO > 0 && altri > 0){
      var meta = Math.round(v0.p * (100 - SCONTO) / 100);
      prezzo = '<s>'+euro(v0.p)+'</s>'+euro(meta)+'<em>-'+SCONTO+'%</em>';
    } else if(SCONTO > 0){
      prezzo = euro(v0.p)+'<em class="poi">-'+SCONTO+'% con un altro pezzo nel carrello</em>';
    } else {
      var meno = v0.pf>v0.p ? Math.round((1-v0.p/v0.pf)*100) : 0;
      prezzo = (v0.pf>v0.p ? '<s>'+euro(v0.pf)+'</s>' : '')+euro(v0.p)+
               (meno>=3 ? '<em>-'+meno+'%</em>' : '');
    }

    var scelta = libere.length>1;
    var testa = '<div class="cs-prop'+(scelta?' cs-prop-scelta':'')+'">'+
      '<img src="'+foto(v0.f||p.f)+'" alt="" loading="lazy">'+
      '<div><div class="nm">'+p.n+'</div><div class="pr">'+prezzo+'</div></div>';
    if(!scelta){
      return testa+'<button type="button" data-var="'+v0.id+'" aria-label="Aggiungi">+</button></div>';
    }
    /* Le quattro pietre, una accanto all'altra: da un cassetto non si sceglie
       una variante da un menu a tendina, si sceglie guardandola. */
    var pastiglie=libere.slice(0,4).map(function(v){
      return '<button type="button" class="cs-pastiglia" data-var="'+v.id+'" title="'+v.et+'">'+
        '<img src="'+foto(v.f,120)+'" alt="" loading="lazy"><span>'+v.et+'</span></button>';
    }).join('');
    return testa+'<div class="cs-pietre">'+pastiglie+'</div></div>';
  }

  /* ---------------------------------------------------------------- disegna */

  function disegna(c){
    var pezzi=c.item_count||0;

    document.querySelectorAll('.strumenti .carrello b').forEach(function(b){
      b.textContent=pezzi;
    });
    document.getElementById('cs-n').textContent = pezzi ? '('+pezzi+')' : '';
    document.getElementById('cs-tot').textContent = euro(c.total_price||0);

    var righe=document.getElementById('cs-righe');
    righe.innerHTML = (c.items&&c.items.length)
      ? c.items.map(riga).join('')
      : '<div class="cs-vuoto">Il carrello è ancora vuoto. Qui sotto trovi da dove ricominciare.</div>';

    /* la barra della spedizione: qui il cross-sell smette di essere una spinta
       e diventa un aiuto ("ti mancano 12 euro") */
    var tot=c.total_price||0, sp=document.getElementById('cs-sped');
    if(!SOGLIA){ sp.innerHTML=''; }
    else if(tot<=0){
      sp.innerHTML='<span>Spedizione gratuita da '+euro(SOGLIA)+'.</span>'+
        '<div class="barra"><i style="width:0"></i></div>';
    } else if(tot>=SOGLIA){
      sp.innerHTML='<span><b>Spedizione gratuita</b>, ci sei.</span>'+
        '<div class="barra"><i style="width:100%"></i></div>';
    } else {
      sp.innerHTML='<span>Ti mancano <b>'+euro(SOGLIA-tot)+'</b> alla spedizione gratuita.</span>'+
        '<div class="barra"><i style="width:'+Math.round(tot/SOGLIA*100)+'%"></i></div>';
    }

    var dentro={};
    (c.items||[]).forEach(function(x){ dentro[x.variant_id]=1; });
    var box=document.getElementById('cs-cross');
    var html=PROPOSTE.map(function(p){
      var altri=0;
      (c.items||[]).forEach(function(x){ if(x.product_id!==p.id) altri+=x.quantity; });
      return proposta(p, dentro, altri);
    }).join('');
    document.getElementById('cs-cross-et').textContent=TITOLO;
    box.closest('.cs-cross').hidden = !html;
    box.innerHTML=html;
  }

  /* ----------------------------------------------------------- apri e chiudi */

  function apri(){
    velo.hidden=false; cassetto.classList.add('aperto');
    cassetto.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
  }
  function chiudi(){
    velo.hidden=true; cassetto.classList.remove('aperto');
    cassetto.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
  }

  document.addEventListener('click', function(e){
    var b=e.target.closest('[data-aggiungi]');
    if(b){ e.preventDefault(); aggiungi(b.dataset.aggiungi, +b.dataset.quanti||1); return; }
    var v=e.target.closest('[data-var]');
    if(v){ e.preventDefault(); aggiungi(v.dataset.var, 1); return; }
    var q=e.target.closest('[data-linea]');
    if(q){ e.preventDefault(); cambia(q.dataset.linea, +q.dataset.quanti); return; }
    if(e.target.closest('.strumenti .carrello')){ e.preventDefault(); aggiorna(true); return; }
    if(e.target===velo || e.target.closest('#cs-chiudi')) chiudi();
  });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') chiudi(); });

  /* `#cassetto` nell'indirizzo apre il carrello appena la pagina e' pronta.
     Serve ai link che devono portare al carrello senza cambiare pagina, e a
     fotografare il cassetto aperto in fase di controllo. */
  aggiorna(location.hash === '#cassetto');
  window.addEventListener('hashchange', function(){
    if(location.hash === '#cassetto') aggiorna(true);
  });
})();

/* ---- la griglia della collezione parte nell'ordine del prototipo ---- */

(function(){
  var lista=document.getElementById('lista');
  if(!lista) return;
  var t=[].slice.call(lista.querySelectorAll('.tessera'));
  function tit(x){ var n=x.querySelector('.nome'); return n?n.textContent:''; }
  t.sort(function(a,b){
    var d=(+b.dataset.rec)-(+a.dataset.rec); if(d) return d;
    d=(+b.dataset.sconto)-(+a.dataset.sconto); if(d) return d;
    var x=tit(a), y=tit(b);
    return x<y?-1:(x>y?1:0);
  });
  t.forEach(function(x){ lista.appendChild(x); });
})();

/* ---- filtri e ordinamento della collezione ---- */
if(document.getElementById('lista')){
(function(){
  var lista=document.getElementById('lista');
  var tutte=[].slice.call(lista.querySelectorAll('.tessera'));
  var conteggio=document.getElementById('conteggio');
  var vuoto=document.getElementById('vuoto');
  function scelte(tipo){
    return [].slice.call(document.querySelectorAll('input[data-tipo="'+tipo+'"]:checked'))
             .map(function(i){return i.value;});
  }
  function filtra(){
    var fam=scelte('fam'), fas=scelte('fascia');
    var soloSconto=document.getElementById('f-sconto').checked;
    var soloRec=document.getElementById('f-rec').checked;
    var n=0;
    tutte.forEach(function(t){
      var ok=true;
      if(fam.length && fam.indexOf(t.dataset.fam)<0) ok=false;
      if(fas.length && fas.indexOf(t.dataset.fascia)<0) ok=false;
      if(soloSconto && +t.dataset.sconto<=0) ok=false;
      if(soloRec && +t.dataset.rec<=0) ok=false;
      t.hidden=!ok; if(ok) n++;
    });
    conteggio.textContent = n===1 ? '1 pezzo' : n+' pezzi';
    vuoto.hidden = n>0;
  }
  function ordina(){
    var v=document.getElementById('ordine').value;
    var c=tutte.slice().sort(function(a,b){
      if(v==='rec') return (+b.dataset.rec)-(+a.dataset.rec);
      if(v==='sconto') return (+b.dataset.sconto)-(+a.dataset.sconto);
      if(v==='su') return (+a.dataset.prezzo)-(+b.dataset.prezzo);
      return (+b.dataset.prezzo)-(+a.dataset.prezzo);
    });
    c.forEach(function(t){lista.appendChild(t);});
  }
  document.querySelectorAll('.filtri input').forEach(function(i){
    i.addEventListener('change', filtra);
  });
  document.getElementById('ordine').addEventListener('change', ordina);
  document.getElementById('azzera').addEventListener('click', function(){
    document.querySelectorAll('.filtri input').forEach(function(i){i.checked=false;});
    filtra();
  });
  filtra();
})();}
/* ---- la scheda prodotto ---- */
if(document.querySelector('.due-scheda')){
(function(){
  /* le miniature e i pallini comandano la stessa foto */
  var mini=[].slice.call(document.querySelectorAll('.mini-riga button'));
  var punti=[].slice.call(document.querySelectorAll('.galleria .pallino'));
  mini.forEach(function(b){
    b.addEventListener('click', function(){
      var n=+b.dataset.i;
      mini.forEach(function(x){ x.classList.toggle('attiva', +x.dataset.i===n); });
      var p=punti.filter(function(x){ return +x.dataset.i===n; })[0];
      if(p) p.click();
    });
  });
  punti.forEach(function(p){
    p.addEventListener('click', function(){
      var n=+p.dataset.i;
      mini.forEach(function(x){ x.classList.toggle('attiva', +x.dataset.i===n); });
    });
  });
  /* le due esperienze: la scelta cambia la cifra scritta nel bottone */
  var quanto=document.getElementById('quanto-compra');
  function eu(v){ return v.toFixed(2).replace('.',',')+'€'; }
  document.querySelectorAll('input[name="esperienza"]').forEach(function(r){
    r.addEventListener('change', function(){
      if(quanto) quanto.textContent=eu(parseFloat(r.value));
    });
  });
  var compra=document.querySelector('.esperienza');
  var barra=document.getElementById('sticky');
  if(compra && barra && 'IntersectionObserver' in window){
    new IntersectionObserver(function(e){
      barra.classList.toggle('su', !e[0].isIntersecting && e[0].boundingClientRect.top<0);
    },{threshold:0}).observe(compra);
  }
})();}
/* ---- la variante scelta sulla scheda ---- */

(function(){
  var zona=document.querySelector('.avpr .varianti');
  if(!zona) return;
  var compra=document.getElementById('compra');
  var barra=document.getElementById('compra-barra');
  var quanto=document.getElementById('quanto-compra');
  var inBarra=document.querySelector('.avpr #sticky .chi span');
  function eu(c){ c=+c||0; return Math.floor(c/100)+','+('0'+(c%100)).slice(-2)+'€'; }
  zona.addEventListener('click', function(e){
    var b=e.target.closest ? e.target.closest('.past-var') : null;
    if(!b || b.disabled) return;
    [].forEach.call(zona.querySelectorAll('.past-var'), function(x){
      x.classList.toggle('viva', x===b);
    });
    var id=b.dataset.variante, prezzo=eu(b.dataset.cent);
    if(compra) compra.dataset.aggiungi=id;
    if(barra)  barra.dataset.aggiungi=id;
    if(quanto) quanto.textContent=prezzo;
    if(inBarra) inBarra.textContent=prezzo;
    /* l'indirizzo segue la scelta: ricaricando, o condividendo il link, si
       riapre sulla variante giusta invece che sulla prima. */
    if(window.history && history.replaceState){
      try{
        var u=new URL(window.location.href);
        u.searchParams.set('variant', id);
        history.replaceState({}, '', u);
      }catch(_){}
    }
  });
})();

/* ---- i blocchi si rivelano scorrendo ---- */

(function(){
  if(!('IntersectionObserver' in window)) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var contenitori=document.querySelectorAll(
    '.avpr .sez > .dentro, .avpr .capo-guida > .dentro, .avpr .scheda > .dentro');
  if(!contenitori.length) return;

  var A_SCAGLIONI='.griglia, .passi, .colonne';
  var bersagli=[];
  [].forEach.call(contenitori, function(d){
    [].forEach.call(d.children, function(el){
      if(el.matches && el.matches(A_SCAGLIONI)){
        [].forEach.call(el.children, function(f,i){ bersagli.push([f, Math.min(i,5)*70]); });
      } else {
        bersagli.push([el, 0]);
      }
    });
  });
  if(!bersagli.length) return;

  function dentroUnCarosello(el){
    for(var p=el.parentElement; p && p!==document.body; p=p.parentElement){
      var o=getComputedStyle(p).overflowX;
      if(o==='auto'||o==='scroll') return true;
    }
    return false;
  }

  var occhio=new IntersectionObserver(function(voci){
    voci.forEach(function(v){
      if(!v.isIntersecting) return;
      v.target.classList.add('vista');
      occhio.unobserve(v.target);
    });
  }, {rootMargin:'0px 0px -7% 0px', threshold:0.04});

  document.documentElement.classList.add('avpr-anima');
  var piega=window.innerHeight*0.92;
  bersagli.forEach(function(c){
    var el=c[0];
    var r=el.getBoundingClientRect();
    if(r.top<piega) return;              /* gia' a video, o nascosto: non si tocca */
    if(dentroUnCarosello(el)) return;
    el.setAttribute('data-rivela','');
    if(c[1]) el.style.transitionDelay=c[1]+'ms';
    occhio.observe(el);
  });
})();

}